import { Component, inject, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AlertModule } from '../../../../../common/modules/bootstrap/alert/alert.module';
import { FontAwesomeDirective } from '../../../../../common/modules/font-awesome/font-awesome.directive';
import { AuthService } from '../../../../../common/services/auth.service';

@Component({
    templateUrl: './reset-password.template.html',
    imports: [
        ReactiveFormsModule, RouterLink,

        AlertModule, FontAwesomeDirective,
    ],
})
export class ResetPasswordComponent implements OnInit {
    private fb = inject(UntypedFormBuilder);
    private service = inject(AuthService);

    form: UntypedFormGroup;
    loading = signal<boolean>(false);
    success = false;

    ngOnInit(): void {
        this.form = this.fb.group({
            username: ['', Validators.required],
        });
    }

    onSubmit(): void {
        if (this.form.invalid) {
            return;
        }

        this.loading.set(true);
        this.service.resetPassword(this.form.value.username)
            .pipe(finalize(() => this.loading.set(false)))
            .subscribe(() => this.success = true);
    }
}
